import React, { PureComponent } from 'react';
import Thumbnail from '../thumbnail';
import { getImgThumbUrl, getMediaId } from '../helpers';
import { trackEvent, trackTime } from '../../../utils/tracking.js';
import { subscribe, unsubscribe, publish } from '../../../utils/eventBus';
import './style.scss';
import PropTypes from 'prop-types';

class Player extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            isPlaying: false,
            showThumbnail: true,
            isMuted: false,
            progress: '100 100',
            currentPlayer: null
        };

        this.togglePlaying = this.togglePlaying.bind(this);
        this.play = this.play.bind(this);
        this.pause = this.pause.bind(this);
        this.pauseInternalPlayers = this.pauseInternalPlayers.bind(this);
        this.playerEnded = this.playerEnded.bind(this);
        this.updateVideoProgress = this.updateVideoProgress.bind(this);
        this.startTime = Date.now();
    }

    componentDidMount() {
        subscribe('pauseAllPlayers', this.pause);
        subscribe('pauseInternalPlayers', this.pauseInternalPlayers);
        this.player.addEventListener('ended', this.playerEnded, false);
        this.player.addEventListener('timeupdate', this.updateVideoProgress, false);
        trackTime('player-component-did-mount', this.startTime, this.props.cardType);

    }

    componentWillUnmount() {
        unsubscribe('pauseAllPlayers', this.pause);
        unsubscribe('pauseInternalPlayers', this.pauseInternalPlayers);
        this.player.removeEventListener('ended', this.playerEnded, false);
        this.player.removeEventListener('timeupdate', this.updateVideoProgress, false);
        trackTime('player-component-did-unmount', this.startTime, this.props.cardType);
    }

    pauseInternalPlayers(payload) {
        if (payload.gigId === this.props.gigId) {
            this.pause();
        }
    }

    playerEnded() {
        this.setState({isPlaying: false});
    }

    updateVideoProgress() {
        const totalPercentage = 2 * 3.14 * 14,
            percentage = this.player.currentTime * totalPercentage / this.player.duration;

        this.setState({progress: `${percentage} 100`});
    }

    play() {
        publish('pauseAllPlayers', {gigId: this.props.gigId});

        if (this.props.media.asset_type === 'video') {
            this.setState({showThumbnail: false});
        }

        this.setState({isPlaying: true});
        this.player.play();
    }

    pause() {
        this.setState({isPlaying: false});
        this.player.pause();
    }

    togglePlaying(e) {
        e.preventDefault();

        if (this.player.paused) {
            this.play();
            trackEvent('player_play', this.props.cardType, this.props.cardSize);

            // Magisto Video AB Test - BI Report
            this.reportForMagistoTest(this.props.gigId, this.props.userId, this.props.media.seller_id, this.props.cardType, this.props.cardSize);
        } else {
            this.pause();
            trackEvent('player_pause', this.props.cardType, this.props.cardSize);
        }
    }

    reportForMagistoTest(gigId, userId, sellerId, cardType, cardSize) {
        const magistoTestGigList = [97708643, 82072996, 44978164, 44098059, 41298300, 35947280, 31326435, 21001527, 13042844, 3663294],
            payload = {gigId, userId, sellerId, group: 'other',
                user: [
                    { id: userId, side: 'general' },
                    { id: sellerId, side: 'seller' }
                ],
                gig: { id: gigId }
            };

        if (magistoTestGigList.indexOf(gigId) === -1) { return; }
        trackEvent('gig_video.click_play', cardType, cardSize, null, payload, 'bigquery');
    }

    render() {
        const { cardSize, media } = this.props,
            videoThumb = cardSize === 'large' ? media.video_thumb_lrg : media.video_thumb,
            mediaId = getMediaId(media.video_stream_url);

        return (
            <div className={`media-player ${cardSize} ${!this.state.showThumbnail ? 'backdrop' : ''}`}>
                {this.state.showThumbnail && <Thumbnail src={getImgThumbUrl(videoThumb)}/>}
                <span className="gig-video-button-wrapper">
                    <span onClick={this.togglePlaying} className={`gig-video-button ${this.state.isPlaying ? 'pause' : 'play'} js-gig-video-button`} data-aux-data="new-video-button-was-clicked" data-graphite='{"label": "gig_listing.video.click"}'></span>
                    <svg className="video-player-progress-wrapper js-video-player-progress-wrapper" viewBox="-2 -4 40 40">
                        <circle className="circle-progress-bar-background" r="14" cx="18" cy="14"/>
                        <circle style={{strokeDasharray: this.state.progress}} className="circle-progress-bar" r="14" cx="18" cy="14"/>
                    </svg>
                </span>
                {media.asset_type === 'video' &&
                    <video key={`player_${mediaId}`} id={`player_${mediaId}`} ref={(ref) => { this.player = ref; }}>
                        {!this.state.showThumbnail &&
                        <source src={media.video_stream_url} type="video/mp4"/> }
                    </video>
                }

                {media.asset_type === 'audio' &&
                    <audio key={`player_${mediaId}`} id={`player_${mediaId}`} ref={(ref) => { this.player = ref; }}>
                        <source src={media.video_stream_url} type="audio/mp4"/>
                    </audio>
                }
            </div>
        );
    }
}


Player.propTypes = {
    gigId: PropTypes.number,
    cardType: PropTypes.string
};

export default Player;



// WEBPACK FOOTER //
// ./src/shared/media/player/index.js